module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/funabashi_ekimae_point3_3-1e06920674b42ce3a3775b5ac0066f2e.jpg";